import React, {useEffect} from "react";
import {ProductionStageTable} from "../../components/production-stages/ProductionStageTable";
import {useSearchProductionStagesGuidePageQuery} from "../../store/backend-api/backend.api";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {useAppSelector} from "../../hooks/useAppSelector";
import {useDataActions} from "../../hooks/useDataActions";
import {DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER} from "../../model/filters/DefaultFilters";
import {tablePageStyle} from "../../utils/TailwindStyles";

export function ProductionStageGuide() {
    const {addData} = useDataActions()

    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER].filter;

    const data = useAppSelector(state => state.data.data[TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER])

    const {data: tablePage} = useSearchProductionStagesGuidePageQuery(filter)

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER}
                         createNavigationURL={'/production-stages/new'}
                         searchInfo={"Поиск по ID и наименованию этапа."}/>
            {data && <ProductionStageTable data={data}/>}
        </div>
    )
}